<template>
  <svg :style="style" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame 72718">
      <!-- <circle id="Ellipse 103" cx="8" cy="8" r="8" fill="#FFCCC5" />
      <path id="Vector 92" d="M7 5L10 8L7 11" stroke="#FE553E" stroke-linecap="round" stroke-linejoin="round" /> -->

      <circle id="Ellipse 103" cx="8" cy="8" r="8" :fill="bgColor" />
      <path id="Vector 92" d="M7 5L10 8L7 11" :stroke="color" stroke-linecap="round" stroke-linejoin="round" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'query-more',
  props: {
    width: {
      type: String,
      default: '16px'
    },
    color: {
      type: String,
      default: '#FE553E'
    },
    bgColor: {
      type: String,
      default: '#FFCCC5'
    }
  },
  data() {
    return {
      style: {
        width: this.width,
        height: this.width,
        'vertical-align': 'middle',
        overflow: 'hidden',
        cursor: 'pointer'
      }
    }
  }
}
</script>